import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, ViewChild } from '@angular/core';
import { AuftragService } from '../api/auftrag.service';
import { AuftragEx, AuftragListItem, ListHeader, ListHeaderOptions, SyncAuftragStatus } from '../api/model/model';
import { AlertController, NavController, LoadingController, Platform, IonSearchbar, PopoverController, ModalController, ActionSheetController } from '@ionic/angular';
import { UiHelper } from '../api/helper/ui-helper';
import { SystemService } from '../api/system.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Logger } from '../api/helper/app-error-logger';
import { Subscription } from 'rxjs';
import { MyApp } from '../api/helper/app';
import { AuftragHelper } from '../api/helper/auftrag-helper';
import { ClickHelper } from '../api/helper/click-helper';
import { AppConfig } from '../api/helper/app.config';
import { Auftragsstatus } from '../api/model/aufteagsstatus';
import { Utils } from '../api/helper/utils';
import { Auftragstyp } from '../api/model/swagger-model';
import { AuftragslisteMenuPopoverComponent } from './auftragdetails/popovers/auftragsliste-menu-popover.component';
import { I18N } from '../api/helper/i18n';
import { VertragSuchenComponent } from '../shared/components/vertrag-suchen/vertrag-suchen.component';
import { AdresseSuchenComponent } from '../shared/components/adresse-suchen/adresse-suchen.component';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AuftragSortierenPage } from './auftrag-sortieren/auftrag-sortieren.page';

import moment from 'moment';
import { KarteWidgetComponent } from '../shared/components/karte-widget/karte-widget.component';
import { AuftragslisteKarteMenuPopoverComponent } from './auftragdetails/popovers/auftragsliste-karte-menu-popover.component';

let datumGestern: string;
let datumHeute: string;
let datumMorgen: string;
let datumUebermorgen: string;

const log = new Logger('AuftragslistePage');

@Component({
    selector: 'app-auftragsliste',
    templateUrl: './auftragsliste.page.html',
    styleUrls: ['./auftragsliste.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragslistePage implements OnInit, OnDestroy, AfterViewInit {
    static instance: AuftragslistePage;

    //  @ViewChild('virtualScroll', { static: false }) virtualScroll: IonVirtualScroll;
    @ViewChild('searchbar', { static: false }) searchbar: IonSearchbar;
    @ViewChild('virtualScroll', { static: false }) virtualScroll: CdkVirtualScrollViewport;

    @ViewChild('karteWidget', { static: false }) karteWidget: KarteWidgetComponent;

    private subscriptions: Subscription[] = [];

    app = MyApp.current;

    auftragstyp: Auftragstyp = Auftragstyp.Unbekannt;
    darstellung = '';

    itemAnsicht: Auftragstyp | string = '';

    oberAuftragKey: string;

    /** Sichtbare Aufträge die in der Oberfläche angezeigt werden */
    // sichtbareAuftraegeGruppen: GruppeVO[] = []; // Auftrag[]>([]);

    /** Alle Aufträge für den aktuellen Auftragstyp */
    alleAuftraege: AuftragListItem[] = [];

    items: AuftragListItem[] = [];

    title: string;
    anzahlAuftraege = 0;

    /** Heute abgeschlossene Aufträge dieses Auftragstyps. */
    anzahlErledigt = 0;

    /** Zusatztext für die Kopfzeile, z.B. "12 offen · 3 erledigt". Leer, wenn die Anzeige deaktiviert ist. */
    zaehlerText = '';
    archivAnzeigen = false;
    sucheAnzeigen = false;
    searchbarSichtbar = false;
    suchtext = '';
    auftragFahrzeugFilterAktiv = false;
    isVisible = false;
    isRefreshing = true;
    geladen = false;

    aktualisierenErforderlich = false;

    auftragAnlegenErlaubt = false;
    refreshLoadingElement: HTMLIonLoadingElement = null;

    draw = 0;

    menuButtonVisible = AppConfig.current.einstellungen.MenueAuftragslisteAnzeigen === 'ja';
    gruppenAnzeigen = AppConfig.current.einstellungen.AuftragGruppenAnzeigen === 'ja';

    maxAnzahlSichtbareAuftraege = 0;
    anzahlNichtSichtbar = 0;
    anzahlGesamt = 0;
    ausgeblendeteAuftraegeAnzeigen = false;
    ausblendungUmgehbar = true;

    minItemHeight = undefined;

    approxItemHeight = '88px';

    activeTab = 'aktuell'; // Default tab

    karteMussAktualisiertWerden = true;
    karteFitToBounds = true;
    isKarteVerfuegbar = false;

    // auftragitemHeight = '140px';

    constructor(
        private auftragService: AuftragService,
        private loadingController: LoadingController,
        private modalController: ModalController,
        private alertCtrl: AlertController,
        private actionSheetCtrl: ActionSheetController,
        private nav: NavController,
        private popoverController: PopoverController,
        private platform: Platform,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private route: ActivatedRoute,
        private systemService: SystemService) {

        AuftragslistePage.instance = this;
    }

    async ngOnInit() {
        log?.debug('ngOnInit start');

        if (AppConfig.current.einstellungen.Animationen === 'nein') {
            // App.loading(true);
            // App.loadingDelayed(true, 500);
        }

        if (MyApp.isCordovaAvailable()) {
            this.subscriptions.push(this.platform.resume.subscribe(() => this.detectChanges('onResume')));
        }

        this.isVisible = true;
        this.geladen = false;
        this.searchbarSichtbar = false;

        this.initialisiereDaten();

        const appConfig = await this.systemService.getAppConfig();

        if (!appConfig.mandant) {
            await UiHelper.showError('Bitte Gerät konfigurieren');
            this.router.navigateByUrl('/einstellungen');
            return;
        }

        try {
            if (this.route.snapshot.data) {
                this.auftragstyp = this.route.snapshot.data.auftragstyp;
                this.darstellung = this.route.snapshot.data.darstellung;
                this.archivAnzeigen = this.route.snapshot.data.archiv;
            }

            const paramAuftragstyp = this.route.snapshot.paramMap.get('auftragstyp');

            if (paramAuftragstyp) {
                this.auftragstyp = parseInt(paramAuftragstyp, 10);
            }

            // TODO: Keine Ahnung ob/wofür das notwendig ist
            const paramDarstellung = this.route.snapshot.paramMap.get('darstellung');

            if (paramDarstellung) {
                this.darstellung = paramDarstellung;
            }

            this.oberAuftragKey = this.route.snapshot.paramMap.get('oberAuftragKey');

            this.updateItemAnsicht();
            this.updateTitle();

            // TODO: Karte konfigurierbar machen
            this.isKarteVerfuegbar = this.auftragstyp === Auftragstyp.Transportauftrag;

            log?.debug('auftragstyp=' + this.auftragstyp);
            log?.debug('darstellung=' + this.darstellung);

            this.subscriptions.push(this.auftragService.auftraegeGeaendert.subscribe(() => {
                log?.info('auftraegeGeaendert');

                if (this.isVisible) {
                    const myDraw = ++this.draw;

                    const timeout = this.isRefreshing ? 0 : 1000;

                    setTimeout(() => {
                        try {
                            if (myDraw == this.draw) {
                                if (this.isVisible) {
                                    this.aktualisiereAuftragsliste();
                                } else {
                                    log?.debug('aktualisierenErforderlich = true #1');
                                    this.aktualisierenErforderlich = true;
                                }
                            }
                        } catch (err) {
                            log.error('auftraegeGeaendert: ' + Utils.getErrorMessage(err));
                        }
                    }, timeout);

                } else {
                    log?.debug('aktualisierenErforderlich = true #2');
                    this.aktualisierenErforderlich = true;
                }
            }));

            await this.aktualisiereAuftragsliste();

            this.subscriptions.push(MyApp.current.configRefreshed.subscribe(() => this.updateConfig()));

            this.subscriptions.push(this.auftragService.syncAuftragStatus.subscribe(status => this.onSyncStatusChanged(status)));

            // TODO CAPACITOR: Klären wofür das notwendig ist.
            // Es gab wharscheinlich ein Problem mit dem Back-Button in der Toolbar.
            // this.subscriptions.push(this.platform.backButton.subscribe(() => this.onBackButton()));

            this.updateConfig();
        } catch (err) {
            UiHelper.showError(err);
        }

        this.geladen = true;

        this.detectChanges('ngOnInit');

        log?.debug('ngOnInit fertig');
    }

    updateItemAnsicht() {
        this.itemAnsicht = this.auftragstyp;

        if (this.darstellung) {
            this.itemAnsicht = this.darstellung;
        }
    }

    private initialisiereDaten() {
        datumGestern = moment().subtract(1, 'days').format('DD.MM.YYYY');
        datumHeute = moment().format('DD.MM.YYYY');
        datumMorgen = moment().add(1, 'days').format('DD.MM.YYYY');
        datumUebermorgen = moment().add(2, 'days').format('DD.MM.YYYY');
    }

    ngAfterViewInit() {
        // this.cdr.detach();
    }

    async ionViewWillEnter() {
        log?.debug('ionViewWillEnter');
        this.isVisible = true;

        if (!this.suchtext) {
            this.searchbarSichtbar = false;
        }
    }

    async ionViewDidEnter() {
        try {
            log?.debug('ionViewDidEnter');

            this.isVisible = true;
            this.searchbarSichtbar = false;

            if (this.suchtext) {
                this.suchtext = '';
                this.filterSichtbareAuftraege();
            }

            // if (this.geladen) {
            //     this.detectChanges('ionViewDidEnter');
            // }

            // Prüfe ob sich das Datum geändert hat seit der letzten Anzeige
            const datum = moment().format('DD.MM.YYYY');

            if (datum != datumHeute) {
                log?.info(`Datum hat sich geändert. ${datumHeute} => ${datum}. Liste wird neu geladen`);
                log?.debug('aktualisierenErforderlich = true #3');
                this.initialisiereDaten();
                this.aktualisierenErforderlich = true;
            }

            if (this.aktualisierenErforderlich) {
                log?.debug('ionViewDidEnter aktualisierenErforderlich');

                this.checkViewportSize();

                this.aktualisierenErforderlich = false;

                // this.geladen = false;

                await this.aktualisiereAuftragsliste();

                // this.geladen = true;

                this.detectChanges('ionViewWillEnter aktualisierenErforderlich');
            }

            MyApp.loading(false);

            MyApp.current.backAction = () => this.goBack();
        } catch (err) {
            log.error('ionViewDidEnter: ' + Utils.getErrorMessage(err));
        }
    }

    ionViewWillLeave() {
        try {
            log?.debug('ionViewWillLeave');

            this.isVisible = false;
            MyApp.current.backAction = null;

            UiHelper.hideLoading();
        } catch (err) {
            log.error('ionViewWillLeave: ' + Utils.getErrorMessage(err));
        }
    }

    // onBackButton() {
    //     log?.info('onBackButton');

    //     if (this.isVisible) {
    //         log?.debug('onBackButton is visible');

    //         setTimeout(() => {
    //             if (this.isVisible) {
    //                 log?.info('onBackButton is still visible');

    //                 this.goBack();
    //             }
    //         }, 350);
    //     }
    // }

    goBack() {
        try {
            log?.info('goBack');

            this.router.navigateByUrl('/');
        } catch (err) {
            log.error('goBack: ' + Utils.getErrorMessage(err));
        }
    }

    updateTitle() {
        this.sucheAnzeigen = false;

        if (this.archivAnzeigen) {
            this.title = 'Archiv';
        } else {
            switch (this.auftragstyp) {
                case 999:
                    this.title = 'Alle Aufträge';
                    break;
                case Auftragstyp.Transportauftrag:
                    this.title = 'Transportaufträge';
                    break;
                case Auftragstyp.Hofchecker:
                    this.title = 'Hofaufträge';
                    this.sucheAnzeigen = true;
                    break;
                case Auftragstyp.Kommissionierung:
                    if (this.darstellung === 'beladung') {
                        this.title = 'Beladung';
                    } else {
                        this.title = 'Kommissionierung';
                    }

                    this.sucheAnzeigen = true;
                    break;
                case Auftragstyp.Wareneingang:
                    this.title = 'Wareneingang';
                    this.sucheAnzeigen = true;
                    break;
                case Auftragstyp.Unbekannt:
                    this.title = 'Unbekannt';
                    break;
            }
        }

        this.title = I18N.instant(this.title);
    }

    async ngOnDestroy() {
        try {
            log?.debug('ngOnDestroy');

            this.subscriptions.forEach(p => p.unsubscribe());
            this.subscriptions = [];

            const topLoading = await this.loadingController.getTop();

            if (topLoading) {
                topLoading.dismiss();
            }
        } catch (err) {
            log.error('ngOnDestroy: ' + Utils.getErrorMessage(err));
        }
    }

    onSyncStatusChanged(status: SyncAuftragStatus): void {
        if (this.refreshLoadingElement) {
            if (status.index) {
                this.refreshLoadingElement.message = 'Lade Aufträge: ' + status.text;
            } else {
                this.refreshLoadingElement.message = status.text;
            }
        }
    }

    async doRefresh(event) {
        try {
            this.isRefreshing = true;

            log?.debug('doRefresh');

            this.refreshLoadingElement = await this.loadingController.create({
                message: 'Aufträge werden geladen...'
            });

            await this.refreshLoadingElement.present();

            event.target.complete();

            try {
                if (!MyApp.isInternetAvailable()) {
                    await this.refreshLoadingElement.dismiss();
                    this.refreshLoadingElement = null;

                    const ok = UiHelper.confirmJaNein('Keine Internetverbindung verfügbar. Trotzdem aktualisieren?');

                    if (!ok) {
                        return;
                    }
                }

                const sycnResult = await this.auftragService.syncAuftraegeMitServer('doRefresh');

                await this.refreshLoadingElement.dismiss();
                this.refreshLoadingElement = null;

                if (!sycnResult) {
                    await UiHelper.showFehlerKommunikation();
                    return;
                }

                if (!sycnResult.success) {
                    await UiHelper.showError(sycnResult.errorMessage);
                    // await this.nav.back();
                    return;
                }
            } catch (err) {
                if (this.refreshLoadingElement) {
                    await this.refreshLoadingElement.dismiss();
                    this.refreshLoadingElement = null;
                }

                UiHelper.showError(err);
            } finally {
                if (this.refreshLoadingElement) {
                    await this.refreshLoadingElement.dismiss();
                    this.refreshLoadingElement = null;
                }

                event.target.complete();
            }
        } catch (err) {
            log.error('doRefresh: ' + Utils.getErrorMessage(err));
        }

        this.isRefreshing = false;
    }

    private async aktualisiereAuftragsliste(): Promise<void> {
        log?.debug('aktualisiereAuftragsliste: ' + this.auftragstyp);

        try {
            this.aktualisierenErforderlich = false;

            if (this.archivAnzeigen) {
                this.alleAuftraege = await this.auftragService.getArchivierteAuftraege(this.auftragstyp);
            } else {
                this.alleAuftraege = await this.auftragService.getAktuelleAuftraege(this.auftragstyp, this.oberAuftragKey);
            }

            log?.debug('aktualisiereAuftragsliste anzahl Aufträge: ' + this.alleAuftraege.length);

            if (this.auftragstyp == Auftragstyp.Transportauftrag && AppConfig.current.einstellungen.AuftragFahrzeugFilterAktiv == 'ja') {
                this.auftragFahrzeugFilterAktiv = true;
                const fahrzeugKennzeichen = MyApp.current.getFahrzeugKennzeichen();

                if (fahrzeugKennzeichen) {
                    // Nur Aufträge für das angemeldete Fahrzeug anzeigen
                    this.alleAuftraege = this.alleAuftraege.filter(p => p.FahrzeugKennung == fahrzeugKennzeichen || p.FahrzeugKennung2 == fahrzeugKennzeichen || p.FahrzeugKennung3 == fahrzeugKennzeichen);
                }
            } else {
                this.auftragFahrzeugFilterAktiv = false;
            }

            if (this.auftragstyp == Auftragstyp.Transportauftrag) {
                this.maxAnzahlSichtbareAuftraege = Utils.parseInt(AppConfig.current.einstellungen.TransportauftragMaxSichtbareAuftraege);
                this.ausblendungUmgehbar = AppConfig.current.einstellungen.TransportauftragAusblendungUmgehbar !== 'nein';
            } else {
                this.maxAnzahlSichtbareAuftraege = 0;
                this.ausblendungUmgehbar = true;
            }

            for (const auftrag of this.alleAuftraege) {
                auftrag.istAusgeblendet = false;
            }

            AuftragHelper.sortiereAuftraege(this.alleAuftraege);

            if (this.maxAnzahlSichtbareAuftraege > 0 && this.alleAuftraege.length > this.maxAnzahlSichtbareAuftraege) {
                // Anzahl der sichtbaren Aufträge einschränken (ZTN)
                if (this.ausgeblendeteAuftraegeAnzeigen) {
                    // Die ausgeblendeten Aufträge sollen grau angezeigt werden
                    const nichtSichtbareAuftraege = this.alleAuftraege.slice(this.maxAnzahlSichtbareAuftraege);

                    for (const auftrag of nichtSichtbareAuftraege) {
                        auftrag.istAusgeblendet = true;
                    }

                    this.anzahlGesamt = 0;
                    this.anzahlNichtSichtbar = 0;
                } else {
                    const nichtSichtbareAuftraege = this.alleAuftraege.slice(this.maxAnzahlSichtbareAuftraege);
                    this.alleAuftraege = this.alleAuftraege.slice(0, this.maxAnzahlSichtbareAuftraege);
                    this.anzahlNichtSichtbar = nichtSichtbareAuftraege.length;
                    this.anzahlGesamt = this.alleAuftraege.length + this.anzahlNichtSichtbar;
                }
            } else {
                this.anzahlGesamt = 0;
                this.anzahlNichtSichtbar = 0;
            }

            this.anzahlAuftraege = this.alleAuftraege.length;

            await this.aktualisiereZaehlerText();

            this.aktualisiereAuftragitemHeight(this.alleAuftraege);

            log?.debug('aktualisiereAuftragsliste. anzahlAuftraege=' + this.anzahlAuftraege);

            this.filterSichtbareAuftraege();

            this.detectChanges('aktualisiereAuftragsliste');
        } catch (err) {
            log.error('aktualisiereAuftragsliste: ' + Utils.getErrorMessage(err));
        }
    }

    /**
     * Baut den Zusatztext für die Kopfzeile: offene und heute erledigte Aufträge.
     *
     * "Offen" ist die bereits gefilterte Liste (Tour, Fahrzeug, Auftragstyp).
     * "Erledigt" wird bewusst auf heute begrenzt und nicht auf die aktuelle Tour:
     * die Fahrer arbeiten laut TourAuswahlOptional auch ohne gestartete Tour,
     * dann wäre eine tourbezogene Zahl immer 0.
     */
    private async aktualisiereZaehlerText(): Promise<void> {
        if (AppConfig.current.einstellungen.AuftragsanzahlAnzeigen !== 'ja' || this.archivAnzeigen) {
            this.anzahlErledigt = 0;
            this.zaehlerText = '';
            return;
        }

        try {
            const heute = moment();
            const archivierteAuftraege = await this.auftragService.getArchivierteAuftraege(this.auftragstyp);

            this.anzahlErledigt = archivierteAuftraege
                .filter(p => p.Statuszeit && moment(p.Statuszeit).isSame(heute, 'day'))
                .length;
        } catch (err) {
            log.warn('aktualisiereZaehlerText: ' + Utils.getErrorMessage(err));
            this.anzahlErledigt = 0;
        }

        this.zaehlerText = `${this.anzahlAuftraege} ${I18N.instant('offen')} · ${this.anzahlErledigt} ${I18N.instant('erledigt')}`;
    }

    private aktualisiereAuftragitemHeight(auftraege: AuftragListItem[]) {
        // const reihenfolgeAnzeigen = this.auftragstyp === Auftragstyp.Transportauftrag
        //     && App.current.TransportauftragReihenfolgeAnzeigen.getValue();

        const schriftgroesse = AppConfig.current.einstellungen.Schriftgroesse;
        let pixelZeile = 21;

        // Im kompakten Layout steht rechts die Adresse, die linke Spalte ist deshalb schmaler.
        const kompaktLayout = this.app.auftragListenLayout === 'kompakt';
        const maxZeichenJeZeile = kompaktLayout ? 20 : 35;

        switch (schriftgroesse) {
            case 'gross':
                pixelZeile = 23;
                break;

            case 'sehr-gross':
                pixelZeile = 26;
                break;
        }

        const app = this.app;

        if (app.auftragZeilenhoehe === 'Dynamisch') {
            for (const listItem of auftraege) {
                listItem.itemHeight = undefined;
                listItem.info1MaxHeight = undefined;
                listItem.info2MaxHeight = undefined;
                listItem.info3MaxHeight = undefined;
            }
        } else if (app.auftragZeilenhoehe === 'Fix') {
            for (const listItem of auftraege) {
                listItem.itemHeight = app.auftragZeilenhoeheMin + 'px';
                listItem.info1MaxHeight = undefined;
                listItem.info2MaxHeight = undefined;
                listItem.info3MaxHeight = undefined;
            }
        } else {
            for (const listItem of auftraege) {
                let zeilen: number;

                let kompakteSpalten = false;

                if (this.auftragstyp == Auftragstyp.Hofchecker) {
                    zeilen = 3;
                } else if (this.auftragstyp == Auftragstyp.Kommissionierung) {
                    zeilen = 2;
                } else if (kompaktLayout) {
                    // Adresse und Abholdatum stehen rechts. Links bleibt nur der Name.
                    kompakteSpalten = true;
                    zeilen = app.transportauftragZeile1Anzeigen ? 1 : 0;
                } else {
                    zeilen = 2;

                    if (listItem.Abholadresse.Strasse) {
                        zeilen++;
                    }

                    if (listItem.Abholadresse.PLZ || listItem.Abholadresse.Ort) {
                        zeilen++;
                    }
                }

                // if (reihenfolgeAnzeigen) {
                //     zeilen++;
                // }

                let info1Zeilen = 0;
                let info2Zeilen = 0;
                let info3Zeilen = 0;

                if (listItem.Info1) {
                    info1Zeilen = 1;

                    if (listItem.Info1.length > maxZeichenJeZeile) {
                        info1Zeilen = 2;
                    }
                }

                if (listItem.Info2) {
                    info2Zeilen = 1;

                    if (listItem.Info2.length > maxZeichenJeZeile) {
                        info2Zeilen = 2;
                    }
                }

                if (listItem.Info3) {
                    info3Zeilen = 1;

                    if (listItem.Info3.length > maxZeichenJeZeile) {
                        info3Zeilen = 2;
                    }
                }

                if (kompakteSpalten) {
                    // Die Höhe ergibt sich aus der höheren der beiden Spalten.
                    let rechteSpalte = 0;

                    if (listItem.Abholadresse.Strasse || listItem.Abholadresse.PLZ || listItem.Abholadresse.Ort) {
                        rechteSpalte++;
                    }

                    if (app.transportauftragAbholdatumAnzeigen) {
                        rechteSpalte++;
                    }

                    zeilen = Math.max(zeilen + info1Zeilen + info2Zeilen + info3Zeilen, rechteSpalte, 1);
                } else {
                    zeilen += info1Zeilen;
                    zeilen += info2Zeilen;
                    zeilen += info3Zeilen;
                }

                const zeilenHoehe = 27 + (zeilen * pixelZeile); // 21; // Margin-Top + Bottom

                listItem.itemHeight = zeilenHoehe + 'px';
                listItem.info1MaxHeight = (info1Zeilen * pixelZeile) + 'px';
                listItem.info2MaxHeight = (info2Zeilen * pixelZeile) + 'px';
                listItem.info3MaxHeight = (info3Zeilen * pixelZeile) + 'px';
            }
        }
    }

    /**
     * Wendet eventuelle Suchfilter an und aktualisiert die Liste der 'sichtbareAuftraege'
     */
    private filterSichtbareAuftraege() {
        log?.debug('filterSichtbareAuftraege');

        let auftragsliste: AuftragListItem[];

        if (this.suchtext && this.suchtext.trim()) {
            auftragsliste = [];

            const parts: string[] = this.suchtext.toLowerCase().trim().split(' ');

            for (const auftrag of this.alleAuftraege) {
                if (!auftrag) {
                    return;
                }

                let isMatch = true;

                for (const str of parts) {
                    if (!auftrag.suchtext.includes(str)) {
                        isMatch = false;
                        break;
                    }
                }

                if (isMatch) {
                    auftragsliste.push(auftrag);
                }
            }
        } else {
            auftragsliste = this.alleAuftraege.filter(p => p);
        }

        if (this.auftragstyp === Auftragstyp.Kommissionierung) {
            // Fertig kommissionierte Aufträge nicht mehr anzeigen.
            auftragsliste = auftragsliste.filter(p => p.Auftragsstatus !== 81);
        }

        log?.debug('filterSichtbareAuftraege. anzahl=' + auftragsliste.length);

        // Prüfe ob sich etwas geändert hat.
        // Wenn ja, ist keine Aktualisierung der Liste erforderlich
        let aktualisierungErforderlich = auftragsliste.length != this.items.length;

        if (!aktualisierungErforderlich) {
            for (let index = 0; index < auftragsliste.length; index++) {
                const a1 = auftragsliste[index];
                const a2 = this.items[index];

                const hashKey = this.getItemKey(a1);

                if (a2.hashKey !== hashKey) {
                    aktualisierungErforderlich = true;
                }

                // Darf erst nach der Prüfung auf Unterschied gesetzt werden.
                // Es kann sein, dass es sich bei a1 und a2 um die gleichen Objekte (Instanzen) handelt
                a1.hashKey = hashKey;
            }
        }

        if (aktualisierungErforderlich) {
            log?.info('Liste wurde aktualisiert, da geändert');
            this.items = [...auftragsliste];

            this.checkViewportSize();
        }

        this.detectChanges('filterSichtbareAuftraege');
    }

    /**
     * Prüft die Größe des Viewports und passt die Anzeige an.
     * Diese Methode sollte aufgerufen werden, wenn sich die Größe des Viewports ändert,
     * z.B. bei der Anzeige von Tastaturen oder beim Wechsel der Bildschirmgröße.
     */
    checkViewportSize() {
        this.virtualScroll?.checkViewportSize();
    }

    getItemKey(a1: AuftragListItem): string {
        return `${a1.Auftragsstatus};${a1.Auftragsnummer};${a1.Info1};${a1.Info2};${a1.Info3};${a1.Abholadresse?.Name1};${a1.Abholadresse?.Name2};${a1.Abholadresse?.Strasse};${a1.Abholadresse?.PLZ};${a1.Abholadresse?.Ort};${a1.Reihenfolge};${a1.PersonalKey}`;
    }

    trackByFn(index: number, item: AuftragListItem) {
        return item ? item.Key : index;
    }

    getHeader(auftrag: AuftragListItem, recordIndex, records: AuftragListItem[]): ListHeader {
        try {
            const that = AuftragslistePage.instance;

            if (!that.isVisible) {
                // Die Liste wird nicht angezeigt. Es wird aber auf einer anderen Seite (z.B. Auftrag-Lieferung)
                // ein Wert in ein Feld eingegeben. Durch das Anzeigen der Tastatur wird ein Resize-Event ausgelöst.
                // Das bewirkt ein Neu-Zeichnen der Tabelle.
                log?.debug('aktualisierenErforderlich = true #4');
                that.aktualisierenErforderlich = true;
                return null;
            }

            let headerGeandert = false;

            if (recordIndex <= 0) {
                headerGeandert = true;
            } else {
                const vorherigerAuftrag = records[recordIndex - 1];

                const options: ListHeaderOptions = {
                    auftragFahrzeugFilterAktiv: that.auftragFahrzeugFilterAktiv,
                    gruppenAnzeigen: that.gruppenAnzeigen
                };

                const headerKey1 = AuftragHelper.getAuftragListHeaderKey(vorherigerAuftrag, options);
                const headerKey2 = AuftragHelper.getAuftragListHeaderKey(auftrag, options);

                if (headerKey1 != headerKey2) {
                    headerGeandert = true;
                }
            }

            if (headerGeandert) {
                let datum = auftrag.AAbholdatum;

                if (datum === datumGestern) {
                    datum = 'Gestern';
                } else if (datum === datumHeute) {
                    datum = 'Heute';
                } else if (datum === datumMorgen) {
                    datum = 'Morgen';
                } else if (datum === datumUebermorgen) {
                    datum = 'Übermorgen';
                }

                if (that.gruppenAnzeigen) {
                    if (auftrag.GruppeBezeichnung) {
                        return {
                            title: auftrag.GruppeBezeichnung,
                            subtitle: datum
                        };
                    } else {
                        return {
                            title: datum,
                            subtitle: null
                        };
                    }
                } else if (that.auftragFahrzeugFilterAktiv) {
                    return {
                        title: auftrag.FahrzeugKennung,
                        subtitle: datum
                    };
                } else {
                    return {
                        title: datum
                    };
                }
            }
        } catch (err) {
            log.error('myHeaderFn: ' + Utils.getErrorMessage(err));
        }

        return null;
    }

    onSearchChanged() {
        this.filterSichtbareAuftraege();

        this.detectChanges('onSearchChanged');
    }

    async onAktuelleAuftraegeAnzeigen() {
        await this.nav.navigateRoot('/auftragsliste/aktuell/' + this.auftragstyp);
    }

    async navigateTo(e: Event, url: string) {
        ClickHelper.click(e, async () => {
            await this.router.navigateByUrl(url);
        });
    }

    private detectChanges(info: string) {
        log?.debug(`detectChanges (${info})`);

        try {
            if (this.isVisible) {
                this.cdr.detectChanges();
            }
        } catch (err) {
            log.warn(Utils.getErrorMessage(err));
        }
    }

    onSuchen() {
        log?.debug('onSuchen');

        this.searchbarSichtbar = true;
        this.suchtext = '';
        this.detectChanges('onSuchen');

        setTimeout(() => {
            if (this.searchbar) {
                try {
                    this.searchbar.setFocus();
                } catch (err) {
                    log.error('setTimeout onSuchen: ' + Utils.getErrorMessage(err), err);
                }
            }
        }, 200);
    }

    async onNeuerAuftrag() {
        log?.debug('onNeuerAuftrag');

        let art: string = AppConfig.current.einstellungen.TransportauftragNeuanlageArt;

        if (art === 'Auswahl') {
            // Der Fahrer wählt die Art der Neuanlage aus den erlaubten Möglichkeiten
            art = await this.frageNeuanlageArt();

            if (!art) {
                // Auswahl abgebrochen
                return;
            }
        }

        if (art === 'Vertrag') {
            // Auftrag soll aus Vertrag erstellt werden
            this.onNeuerAuftragAusVertrag();
            return;
        }

        if (art === 'Adresse') {
            // Auftrag soll mit einer Adresse aus ERP-System erstellt werden
            this.onNeuerAuftragMitAdresse();
            return;
        }

        let text;

        if (this.auftragstyp === Auftragstyp.Transportauftrag) {
            text = 'NeuenTransportauftragAnlegen'
        } else if (this.auftragstyp === Auftragstyp.Wareneingang) {
            text = 'NeuenWareneingangAnlegen'
        } else {
            text = 'NeuenHofauftragAnlegen'
        }

        const ok = await UiHelper.confirmJaNein(I18N.instant(text));

        if (!ok) {
            return
        }

        // Adresse auswählen

        let key: string;
        let workflowName;

        if (this.auftragstyp === Auftragstyp.Transportauftrag) {
            key = 'T' + Utils.uuid();
            workflowName = AppConfig.current.einstellungen.TransportauftragNeuanlageWorkflowName;
        } else if (this.auftragstyp === Auftragstyp.Wareneingang) {
            key = 'W' + Utils.uuid();
            workflowName = AppConfig.current.einstellungen.WareneingangeuanlageWorkflowName;
        } else {
            key = 'H' + Utils.uuid();
            workflowName = AppConfig.current.einstellungen.HofauftraegeNeuanlageWorkflowName;
        }

        const now = moment();

        const auftrag: AuftragEx = {
            Key: key,
            Auftragstyp: this.auftragstyp as any,
            Auftragsnummer: -1,
            Auftragsstatus: Auftragsstatus.Neu,
            AAbholdatum: now.format('DD.MM.YYYY'),
            IstNeuanlage: true,
            Statusmeldung: '',
            StatusmeldungKey: '',
            Abholadresse: {
                Name1: 'Dummy',
                Name2: ''
            },
            Unterschriften: [],
            Optionen: null,
            statusmeldungen: [],
            Anlagen: [],
            WorkflowName: workflowName
        };

        const aktuelleTour = this.app.aktuelleTour.getValue();

        if (aktuelleTour) {
            auftrag.TourKey = aktuelleTour.TourKey;
        }

        await this.auftragService.speichereAuftrag(auftrag);

        await this.router.navigateByUrl('/auftragsliste/details/' + auftrag.Key);

        // Alter Code um einen Auftrag über eine Auftragsnummer anzulegen. War nur für HOPPECKE geplant
        // const alert = await this.alertController.create({
        //     cssClass: 'input-alert',
        //     message: 'Auftragsnummer',
        //     header: 'Neuer Auftrag',
        //     inputs: [
        //         {
        //             name: 'auftragsnummer',
        //             type: 'text',
        //             placeholder: '',
        //             value: ''
        //         }
        //     ],
        //     buttons: [
        //         {
        //             text: 'Abbruch',
        //             role: 'cancel',
        //             handler: data => {
        //                 // abbruch
        //             }
        //         },
        //         {
        //             text: 'OK',
        //             role: 'accept',
        //             handler: async data => {
        //                 if (!data.auftragsnummer || !data.auftragsnummer.trim()) {
        //                     return false;
        //                 }

        //                 const auftragsnummer = data.auftragsnummer;

        //                 try {
        //                     let key: string;

        //                     if (this.auftragstyp === Auftragstyp.Hofchecker) {
        //                         key = 'H' + auftragsnummer;
        //                     } else {
        //                         key = 'T' + auftragsnummer;
        //                     }

        //                     let auftrag = await this.auftragService.getAuftrag(key);

        //                     const aktuelleTour = App.current.aktuelleTour.getValue();

        //                     if (!auftrag) {
        //                         auftrag = {
        //                             Key: key,
        //                             Auftragstyp: this.auftragstyp as any,
        //                             Auftragsnummer: auftragsnummer,
        //                             Auftragsstatus: Auftragsstatus.Neu,
        //                             Statusmeldung: '',
        //                             StatusmeldungKey: '',
        //                             Abholadresse: {
        //                                 Name1: auftragsnummer,
        //                                 Name2: 'Neu'
        //                             },
        //                             Unterschriften: [],
        //                             Optionen: null,
        //                             statusmeldungen: [],
        //                             Anlagen: [],
        //                             WorkflowName: AppConfig.current.einstellungen.AuftragScannenNeuanlageWorkflowName
        //                         };

        //                         if (aktuelleTour) {
        //                             auftrag.TourKey = aktuelleTour.TourKey;
        //                         }

        //                         await this.auftragService.speichereAuftrag(auftrag);
        //                     }

        //                     await this.router.navigateByUrl('/auftragsliste/details/' + auftrag.Key);
        //                 } catch (err) {
        //                     UiHelper.showError(err);
        //                 }
        //             }
        //         }
        //     ]
        // });

        // await alert.present();
    }

    /**
     * Zeigt dem Fahrer ein Auswahlfenster der erlaubten Neuanlage-Arten
     * (Einstellung TransportauftragNeuanlageArtAuswahl) und liefert die gewählte Art zurück.
     * Gibt null zurück, wenn abgebrochen wurde.
     */
    async frageNeuanlageArt(): Promise<string | null> {
        log?.debug('frageNeuanlageArt');

        const labels: { [key: string]: string } = {
            Standard: 'Standard',
            Vertrag: 'Aus Vertrag',
            Adresse: 'Adresse'
        };

        const konfig = AppConfig.current.einstellungen.TransportauftragNeuanlageArtAuswahl || 'Standard,Vertrag,Adresse';

        const arten = konfig
            .split(',')
            .map(s => s.trim())
            .filter(s => !!labels[s]);

        if (arten.length === 0) {
            arten.push('Standard');
        }

        // Nur eine Art erlaubt -> keine Rückfrage nötig
        if (arten.length === 1) {
            return arten[0];
        }

        const buttons: any[] = arten.map(a => ({
            text: labels[a],
            data: a
        }));

        buttons.push({
            text: I18N.instant('Abbrechen'),
            role: 'cancel',
            data: null
        });

        const actionSheet = await this.actionSheetCtrl.create({
            header: I18N.instant('Auftrag anlegen'),
            buttons: buttons
        });

        await actionSheet.present();

        const result = await actionSheet.onDidDismiss();

        return result.data || null;
    }

    async onNeuerAuftragAusVertrag() {
        log?.debug('onNeuerAuftragAusVertrag');

        if (this.auftragstyp === Auftragstyp.Transportauftrag) {
            if (this.app.tourStartenErforderlich.getValue()) {
                if (!this.app.tourGestartet.getValue()) {
                    UiHelper.showAlert('Bitte Tour erst starten');
                    return;
                }
            }
        }

        const modal = await this.modalController.create({
            component: VertragSuchenComponent,
            componentProps: {
                auftragstyp: this.auftragstyp
            }
        });

        await modal.present();

        log?.debug('modal', modal);

        const result = await modal.onDidDismiss();

        log?.debug('result', result);

        if (result?.data) {
            if (result.data.type === 'neuer-auftrag') {
                const auftrag = result.data.auftrag;

                await Utils.delay(100);

                const routerLink = '/auftragsliste/details/' + auftrag.Key;
                this.router.navigateByUrl(routerLink);

                await Utils.delay(100);

                UiHelper.showAlert('Auftrag wurde angelegt', 'Auftrag');
            }
        }
    }

    async onNeuerAuftragMitAdresse() {
        log?.debug('onNeuerAuftragMitAdresse');

        if (this.auftragstyp === Auftragstyp.Transportauftrag) {
            if (this.app.tourStartenErforderlich.getValue()) {
                if (!this.app.tourGestartet.getValue()) {
                    UiHelper.showAlert('Bitte Tour erst starten');
                    return;
                }
            }
        }

        const modal = await this.modalController.create({
            component: AdresseSuchenComponent,
            componentProps: {
                auftragstyp: this.auftragstyp
            }
        });

        await modal.present();

        log?.debug('modal', modal);

        const result = await modal.onDidDismiss();

        log?.debug('result', result);

        if (result?.data) {
            if (result.data.type === 'neuer-auftrag') {
                const auftrag = result.data.auftrag;

                await Utils.delay(100);

                const routerLink = '/auftragsliste/details/' + auftrag.Key;
                this.router.navigateByUrl(routerLink);

                await Utils.delay(100);

                UiHelper.showAlert('Auftrag wurde angelegt', 'Auftrag');
            }
        }
    }

    private updateConfig() {
        log?.debug('updateConfig');

        let neuanlageErlaubt = false;

        if (this.app.auftragScannenVerfuegbar.getValue() && this.app.auftragScannenNeuanlageErlaubt.getValue()) {
            neuanlageErlaubt = true;
        } else {
            switch (this.auftragstyp) {
                case Auftragstyp.Transportauftrag:
                    neuanlageErlaubt = this.app.TransportauftragNeuanlageErlaubt.getValue();
                    break;

                case Auftragstyp.Hofchecker:
                    neuanlageErlaubt = this.app.HofauftraegeNeuanlageErlaubt.getValue();
                    break;

                case Auftragstyp.Wareneingang:
                    neuanlageErlaubt = true; // TODO: eventuell konfigurierbar machen
                    break;
            }
        }

        this.auftragAnlegenErlaubt = neuanlageErlaubt;

        this.minItemHeight = MyApp.current.auftragZeilenhoeheMin + 'px';
        this.approxItemHeight = this.minItemHeight;
    }

    async onShowMenu(event: any) {
        log?.debug('onShowMenu', event);

        const popover = await this.popoverController.create({
            component: AuftragslisteMenuPopoverComponent,
            cssClass: 'auftrag-menu',
            event: event,
            translucent: true,
            componentProps: {
                'auftragstyp': this.auftragstyp,
                'archivAnzeigen': this.archivAnzeigen,
                'auftragAnlegenErlaubt': this.auftragAnlegenErlaubt,
                'suchenErlaubt': true // !this.archivAnzeigen,
            }
        });

        await popover.present();

        const result = await popover.onWillDismiss();

        switch (result.data) {
            case 'tour-laden':
                this.nav.navigateForward('/tour/laden');
                break;

            case 'tour-starten':
                this.nav.navigateForward('/tour/start');
                break;

            case 'tour-beenden':
                this.nav.navigateForward('/tour/ende');
                break;

            case 'archiv-anzeigen':
                this.nav.navigateForward('/auftragsliste/archiv/' + this.auftragstyp);
                break;

            case 'aktuelle-auftraege-anzeigen':
                this.onAktuelleAuftraegeAnzeigen();
                break;

            case 'auftraege-sortieren':
                this.onAuftraegeSortieren();
                break;

            case 'neuer-auftrag':
                this.onNeuerAuftrag();
                break;

            case 'suchen':
                this.onSuchen();
                break;
        };
    }

    async onShowKarteMenu(event: any) {
        log?.debug('onShowKarteMenu', event);

        const popover = await this.popoverController.create({
            component: AuftragslisteKarteMenuPopoverComponent,
            cssClass: 'auftrag-menu',
            event: event,
            translucent: true,
            componentProps: {
                'auftragstyp': this.auftragstyp,
                'auftragAnlegenErlaubt': this.auftragAnlegenErlaubt,
            }
        });

        await popover.present();

        const result = await popover.onWillDismiss();

        switch (result.data) {
            case 'tour-laden':
                this.nav.navigateForward('/tour/laden');
                break;

            case 'tour-starten':
                this.nav.navigateForward('/tour/start');
                break;

            case 'tour-beenden':
                this.nav.navigateForward('/tour/ende');
                break;

            case 'auftraege-sortieren':
                this.onAuftraegeSortieren();
                break;

            case 'neuer-auftrag':
                this.onNeuerAuftrag();
                break;
        };
    }

    async onNichtSichtbareAuftraegeClicked() {
        if (!this.ausblendungUmgehbar) {
            await UiHelper.showAlert('Es ist nicht möglich, weitere Aufträge anzusehen, solange noch offene Aufträge vorhanden sind.');
            return;
        }

        const ok = await UiHelper.confirmJaNein('Ausgeblendete Aufträge anzeigen?');

        if (ok) {
            this.ausgeblendeteAuftraegeAnzeigen = true;
            await this.aktualisiereAuftragsliste();
        }
    }

    async onAuftraegeSortieren() {
        log?.info('onAuftraegeSortieren');

        if (this.archivAnzeigen) {
            UiHelper.showAlert('Archivierte Aufträge können nicht sortiert werden');
            return;
        }

        const modal = await UiHelper.modalController.create({
            component: AuftragSortierenPage,
            componentProps: {
                'auftraege': this.alleAuftraege
            }
        });

        await modal.present();
        await modal.onDidDismiss();

        await this.aktualisiereAuftragsliste();

        if (this.activeTab === 'karte') {
            await Utils.delay(50);

            await this.karteWidget?.updateMap(false);
        }
    }

    async onTabChanged(e: any) {
        this.activeTab = e.tab;

        log?.debug('Aktiver Tab:', this.activeTab);

        const oldArchivAnzeigen = this.archivAnzeigen;

        this.suchtext = '';
        this.searchbarSichtbar = false;

        if (this.activeTab === 'archive') {
            this.archivAnzeigen = true;
        } else {
            this.archivAnzeigen = false;
        }

        if (oldArchivAnzeigen !== this.archivAnzeigen) {
            await this.aktualisiereAuftragsliste();
        }

        if (this.activeTab === 'karte' && this.karteMussAktualisiertWerden) {
            this.archivAnzeigen = false;

            // Es muss etwas gewartet werden, bis die Karte wirklich initialisiert ist.
            // Ansonsten funktioniert das Setzen der "Bounds" nicht richtig.
            await Utils.delay(50);

            if (this.karteWidget) {
                this.karteWidget?.updateMap(this.karteFitToBounds);

                this.karteMussAktualisiertWerden = false;
                this.karteFitToBounds = false;
            }
        } else if (this.activeTab === 'archive') {
            this.archivAnzeigen = true;
        } else {
            this.archivAnzeigen = false;
        }

        this.checkViewportSize();
    }
}
